module.exports = __webpack_public_path__ + "img/mobi_P3.fad88ed9.png";